import { Crown, ShieldCheck, Users, Settings2, ChevronDown } from "lucide-react";
import { TIER_LEVEL, TIER_NAME, tierKey } from "@/pages/admin/adminSections";

const TIER_ICON = { owner: Crown, safety_admin: ShieldCheck, admin: Users, technical_admin: Settings2 };
const TIER_STYLE = {
  owner: "border-amber-400/40 bg-amber-400/10 text-amber-300",
  safety_admin: "border-violet-400/40 bg-violet-400/10 text-violet-300",
  admin: "border-sky-400/40 bg-sky-400/10 text-sky-300",
  technical_admin: "border-emerald-400/40 bg-emerald-400/10 text-emerald-300",
};

export default function AdminTierBadge({ user }) {
  const key = tierKey(user);
  if (!key) return null;
  const Icon = TIER_ICON[key];
  const name = TIER_NAME[key];
  return (
    <div data-testid="admin-tier-badge" className={`flex items-center gap-3 border px-3 py-2 ${TIER_STYLE[key]}`}>
      <span className="w-8 h-8 rounded-full bg-black/40 grid place-items-center"><Icon size={15} /></span>
      <div className="leading-tight">
        <div className="text-sm font-semibold text-white" data-testid="admin-tier-name">
          {user.display_name || user.handle} <span className="text-zinc-400 font-normal">({name})</span>
        </div>
        <div className="text-[11px] uppercase tracking-widest" data-testid="admin-tier-level">
          {name} • Level {TIER_LEVEL[key]}
        </div>
      </div>
      <ChevronDown size={14} className="text-zinc-500 hidden sm:block" />
    </div>
  );
}
